export const PERMISSIONS = {
  AGENTS_READ: "agents.read",
  AGENTS_CREATE: "agents.create",
  AGENTS_UPDATE: "agents.update",
  AGENTS_DELETE: "agents.delete",
  AGENTS_RUN: "agents.run",
  WORKFLOWS_READ: "workflows.read",
  WORKFLOWS_CREATE: "workflows.create",
  WORKFLOWS_UPDATE: "workflows.update",
  WORKFLOWS_DELETE: "workflows.delete",
  WORKFLOWS_RUN: "workflows.run",
  WORKFLOWS_APPROVE: "workflows.approve",
  TOOLS_READ: "tools.read",
  TOOLS_CREATE: "tools.create",
  TOOLS_UPDATE: "tools.update",
  TOOLS_CONFIGURE: "tools.configure",
  TOOLS_DELETE: "tools.delete",
  KNOWLEDGE_READ: "knowledge.read",
  KNOWLEDGE_CREATE: "knowledge.create",
  KNOWLEDGE_UPDATE: "knowledge.update",
  KNOWLEDGE_DELETE: "knowledge.delete",
  RUNS_READ: "runs.read",
  RUNS_START: "runs.start",
  RUNS_CANCEL: "runs.cancel",
  AUDIT_READ: "audit.read",
  USERS_READ: "users.read",
  USERS_MANAGE: "users.manage",
  ROLES_READ: "roles.read",
  ROLES_MANAGE: "roles.manage",
  CONFIG_READ: "config.read",
  CONFIG_BRANDING_MANAGE: "config.branding.manage",
  CONFIG_FEATURE_FLAGS_MANAGE: "config.feature_flags.manage",
  CONFIG_KEYS_MANAGE: "config.keys.manage",
} as const;
